module.exports = __webpack_public_path__ + "img/unique.7ca7e75.jpg";